document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.tabbed-collections-section');
  if (!section) return;

  const tabs = section.querySelectorAll('.tab-btn');
  const contents = section.querySelectorAll('.tab-content');
  const prevBtn = section.querySelector('.carousel-arrow.prev');
  const nextBtn = section.querySelector('.carousel-arrow.next');

  let currentIndex = 0;
  let activeCarousel = null;

  function getItemsPerView() {
    if (window.innerWidth <= 767) return 1;
    if (window.innerWidth <= 991) return 2;
    return 4;
  }

  function updateCarousel() {
    if (!activeCarousel) return;

    const cards = activeCarousel.querySelectorAll('.product-card');
    const itemsPerView = getItemsPerView();

    if (cards.length <= itemsPerView) {
      activeCarousel.style.transform = 'translateX(0)';
      return;
    }

    const cardWidth = cards[0].offsetWidth + 20;
    activeCarousel.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
  }

  function setActiveCarousel() {
    const activeTab = section.querySelector('.tab-content.active');
    if (!activeTab) return;

    activeCarousel = activeTab.querySelector('.products-carousel');
    currentIndex = 0;
    updateCarousel();
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(btn => btn.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));

      this.classList.add('active');

      const target = section.querySelector(`#${this.dataset.tab}`);
      if (target) {
        target.classList.add('active');
      }

      setActiveCarousel();
    });
  });

  nextBtn.addEventListener('click', function () {
    if (!activeCarousel) return;

    const cards = activeCarousel.querySelectorAll('.product-card');
    const itemsPerView = getItemsPerView();
    const maxIndex = cards.length - itemsPerView;

    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  });

  prevBtn.addEventListener('click', function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  let startX = 0;
  let endX = 0;

  section.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  });

  section.addEventListener('touchend', function (e) {
    endX = e.changedTouches[0].clientX;

    if (startX - endX > 50) {
      nextBtn.click();
    }

    if (endX - startX > 50) {
      prevBtn.click();
    }
  });

  window.addEventListener('resize', updateCarousel);

  setActiveCarousel();
});